import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgPasswordResetRequestComplete',
})
export default class CmgPasswordResetRequestComplete extends Vue {
  
  @Prop({ default: '', type: String })
  email!: string;

  onClickDone(): void {
    this.redirectToSignIn();
  }

  onClickRetry() {
    this.$emit('retry-password-reset');
  }

  private redirectToSignIn() {
    if(this.$router.currentRoute.name == Routes.PasswordResetRequestPage) {
      this.$router.push({name: Routes.SignIn});
    } else if(this.$router.currentRoute.name == Routes.VendorPasswordResetRequestPage) {
      this.$router.push({name: Routes.VendorSignIn});
    } else {
      this.$services.ui.setModalVisibility('signIn', false);
    }
  }
}
